"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));
var _excluded = ["children", "classes", "onClose"];
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
var DialogTitle = function DialogTitle(props) {
  var children = props.children,
    classes = props.classes,
    onClose = props.onClose,
    other = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/_react.default.createElement(_core.DialogTitle, _extends({
    disableTypography: true,
    className: classes.root
  }, other), /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "h6"
  }, children), onClose ? /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    "aria-label": "close",
    className: classes.closeButton,
    onClick: onClose
  }, /*#__PURE__*/_react.default.createElement(_Close.default, null)) : null);
};
var styles = function styles(theme) {
  return {
    root: {
      margin: 0,
      paddingTop: '8px',
      paddingLeft: '30px',
      backgroundColor: '#6D89A2',
      height: '45px',
      color: '#FFFFFF',
      fontFamily: 'Lato',
      fontSize: '20px',
      fontWeight: 600,
      letterSpacing: '0',
      lineHeight: '37px'
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1) - 4,
      color: '#FFFFFF'
    }
  };
};
var _default = (0, _core.withStyles)(styles, {
  withTheme: true
})(DialogTitle);
exports.default = _default;